import { defineStore } from 'pinia'
import { ref } from 'vue'

const TOAST_TIMEOUT_DURATION = 2500
let toastMessageTimeout = null

export const useToastStore = defineStore('toast', () => {
  const isOpen = ref(false)
  const text = ref(null)
  const icon = ref(null)
  const secondary = ref(false)

  /**
   * @param {string|Error} text an Error is coerced to its message
   * @param {string} [icon]
   * @param {number} [duration] in ms
   * @param {boolean} [secondary]
   */
  function showToastMessage({
    text: newText,
    icon: newIcon,
    duration = TOAST_TIMEOUT_DURATION,
    secondary: newSecondary = false,
  }) {
    // Errors can end up here when an unmapped failure escapes the API error
    // interceptor; AppToast's text prop only accepts strings.
    const message = newText instanceof Error ? newText.message : newText

    if (!message) {
      return
    }

    clearTimeout(toastMessageTimeout)

    if (newIcon) {
      icon.value = newIcon
    }

    text.value = message
    secondary.value = newSecondary
    isOpen.value = true

    toastMessageTimeout = setTimeout(() => {
      isOpen.value = false

      // The animation needs to finish before removing the text/icon
      setTimeout(() => {
        text.value = null
        icon.value = null
        secondary.value = false
      }, 250)
    }, duration)
  }

  return {
    isOpen,
    text,
    icon,
    secondary,
    showToastMessage,
  }
})
